import { useSelector } from 'react-redux';
import { ThemeSettings } from './theme/Theme';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { RouterProvider } from 'react-router';
import router from './routes/Router'

// import BestWebBadge from './layouts/badges/BestWebBadge';

function App() {

  const theme = ThemeSettings();
  const customizer = useSelector((state) => state.customizer);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <RouterProvider router={router} />
    </ThemeProvider>
  );
}

export default App
